export const ATTR_INSIGHT_PERFORMANCE = 'ATTR_INSIGHT_PERFORMANCE';
export const ATTR_INSIGHT_SEGMENTS = 'ATTR_INSIGHT_SEGMENTS';
export const ATTR_INSIGHT_GEOGRAPHIC = 'ATTR_INSIGHT_GEOGRAPHIC';
export const ATTR_INSIGHT_DEMOGRAPHIC = 'ATTR_INSIGHT_DEMOGRAPHIC';
export const ATTR_INSIGHT_ADVANCE_METRICS = 'ATTR_INSIGHT_ADVANCE_METRICS';
export const ATTR_INSIGHT_BENCHMARK = 'ATTR_INSIGHT_BENCHMARK';
export const ATTR_INSIGHT_CLEAR = 'ATTR_INSIGHT_CLEAR';
